exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-36cfd434] #awaitingPickup .ivu-steps-content,[data-v-36cfd434] #delivering .ivu-steps-content{text-decoration:underline;cursor:pointer}", ""]);

// exports
